module.exports = __webpack_public_path__ + "img/filters-white.be37bf26.png";